import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../services/FormService';
import {Checkbox} from 'primeng/checkbox';
import {RadioButton} from 'primeng/radiobutton';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-logo',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox,
    RadioButton
  ],
  template: `
    <div class="form-row">
      <label>
        {{Yii.t('app', 'Show logo')}}
      </label>
      <div>
        <p-checkbox
          [(ngModel)]="fsvc.form.showLogo"
          binary="true"
          (ngModelChange)="resetLogoAlignment()"/>
      </div>
    </div>

    @if (fsvc.form.showLogo) {
      <div class="form-row">
        <label>
          {{Yii.t('app', 'Logo Align')}}
        </label>
        <div class="flex-col gap-8px">
          @for (alignLogo of logoAligns; track alignLogo.value) {
            <div class="flex-row gap-8px">
              <p-radio-button [(ngModel)]="fsvc.form.logoAlign" [value]="alignLogo.value"/>
              <span>{{ alignLogo.title }}</span>
            </div>
          }
        </div>
      </div>
    }
  `
})
export class FormLogoComponent {
  Yii = Yii;

  public logoAligns = [
    {title: 'Center', value: 'center'},
    {title: 'Left', value: 'left'},
    {title: 'Right', value: 'right'}
  ];

  constructor(public fsvc: FormService) {}

  resetLogoAlignment(): void {
    if (!this.fsvc.form.showLogo) {
      this.fsvc.form.logoAlign = '';
    }
  }
}
